var map = {
	"./avenir_next-bold": 557,
	"./avenir_next-bold.eot": 705,
	"./avenir_next-bold.svg": 557,
	"./avenir_next-bold.ttf": 706,
	"./avenir_next-bold.woff": 707,
	"./avenir_next-bold.woff2": 708,
	"./avenir_next-demi": 558,
	"./avenir_next-demi.eot": 709,
	"./avenir_next-demi.svg": 558,
	"./avenir_next-demi.ttf": 710,
	"./avenir_next-demi.woff": 711,
	"./avenir_next-demi.woff2": 712,
	"./avenir_next-medium": 559,
	"./avenir_next-medium.eot": 713,
	"./avenir_next-medium.svg": 559,
	"./avenir_next-medium.ttf": 714,
	"./avenir_next-medium.woff": 715,
	"./avenir_next-medium.woff2": 716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 704;